import { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import api from "@/lib/api";
import { fmtDate, creditColor, creditLabel, txnTypeLabel } from "@/lib/credits";
import { Loader2, Wallet } from "lucide-react";

export default function CreditHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/credits/history").then(({ data }) => setRows(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <DashboardLayout title="Credit History">
      <div className="mb-6">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#E30613]">Certificate Credits</p>
        <h2 className="mt-2 font-display text-2xl font-semibold tracking-tight text-white">Your credit history</h2>
        <p className="mt-1 text-sm text-neutral-500">A permanent, auditable ledger of every credit movement.</p>
      </div>
      <div className="overflow-hidden rounded-2xl border border-white/[0.06] bg-[#141414]" data-testid="credit-history-table">
        {loading ? (
          <div className="flex items-center justify-center py-20 text-neutral-500"><Loader2 className="h-5 w-5 animate-spin" /></div>
        ) : rows.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/[0.04] text-neutral-500"><Wallet className="h-6 w-6" /></span>
            <p className="mt-4 text-sm text-neutral-400">No credit activity yet</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-white/[0.06] text-xs uppercase tracking-wider text-neutral-500">
                  <th className="px-6 py-4 font-medium">Date</th>
                  <th className="px-6 py-4 font-medium">Activity</th>
                  <th className="px-6 py-4 font-medium">Reference</th>
                  <th className="px-6 py-4 font-medium">Credits</th>
                  <th className="px-6 py-4 font-medium">Balance After</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-b border-white/[0.04] hover:bg-white/[0.03]">
                    <td className="px-6 py-4 text-sm text-neutral-400">{fmtDate(r.created_at, true)}</td>
                    <td className="px-6 py-4 text-sm text-white">{txnTypeLabel[r.transaction_type] || r.transaction_type}</td>
                    <td className="px-6 py-4 font-mono text-sm text-neutral-300">{r.reference || "—"}</td>
                    <td className={`px-6 py-4 text-sm font-semibold ${creditColor(r.credit_amount)}`}>{creditLabel(r.credit_amount)}</td>
                    <td className="px-6 py-4 text-sm text-neutral-300">{r.balance_after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
